import { useNavigate } from "react-router-dom";
import useCanGoBack from "./useCanGoBack";
import { HOME_PATH } from "app/constants/variables";

const useGoBack = () => {
  const navigate = useNavigate();
  const canGoBack = useCanGoBack();

  const goBack = (fallback = HOME_PATH) => {
    if (canGoBack) {
      navigate(-1);
      return;
    }

    if (fallback) {
      navigate(fallback);
      return;
    }
  };

  return goBack;
};

export default useGoBack;
